<script setup lang="ts">
import { computed } from 'vue'
import jdroidLogo from '@/assets/images/ide/JDroidIconLatest.svg'
import { useJdroidStore } from '@/stores/jdroid.store'
import { useIdeStore } from '@/stores/ide.store'
import jdroidService from '@/services/ide/jdroid.service'
import Credit from '@/components/ide/ide/ai/jdroid/CreditComp.vue'
import Welcome from '@/components/ide/ide/ai/jdroid/WelcomeComp.vue'
import Chat from '@/components/ide/ide/ai/jdroid/ChatComp.vue'
import editorService from '@/services/ide/editor.service'
import { IDEVIEWTABS, TAB_BUTTON_POSITION, TAB_ICONS_NAMES } from '@/utils/tabs'
import { IDEVIEWTABS_MOBILE } from '@/utils/tabs'
import TabCompTitleBar from '@/components/ide/ide/TabCompTitleBar.vue'
import { UNLIMITED_LIMIT } from '@/utils/sharedData/plans'

const props = defineProps({
  currentPosition: {
    type: String,
    required: false
  },
  showTabSettings: {
    type: Boolean,
    required: false
  },
  tabPosition: {
    type: String,
    required: false,
    default: TAB_BUTTON_POSITION.BOTTOM
  },
  currentTabSize: {
    type: Object,
    required: false
  }
})

const jdroidStore = useJdroidStore()
const ideStore = useIdeStore()

const showWelcome = computed(() => jdroidStore.chatList.length == 0)
const chatList = computed(() => {
  return jdroidStore.chatList
})
const promoteGetCredit = computed(() => {
  return jdroidStore.quota !== UNLIMITED_LIMIT
})

/**
 * clear chat
 */
const clearChat = async () => {
  await new Promise((resolve) => setTimeout(resolve, 100))
  editorService.resizeCodeEditor()
  jdroidService.clearChat()
}
</script>

<template>
  <div
    :class="[
      {
        'h-full min-w-full lg:w-full': props.currentPosition == TAB_BUTTON_POSITION.BOTTOM
      },
      { 'overflow-auto': ideStore.currentMobileTab == IDEVIEWTABS_MOBILE.JDROID }
    ]"
  >
    <div class="relative flex h-full w-full flex-col" :id="`${IDEVIEWTABS.JDROID}-main`">
      <!-- props.currentPosition == TAB_BUTTON_POSITION.BOTTOM -->
      <TabCompTitleBar
        titleName="JDroid AI"
        :icon="jdroidLogo"
        :tabPosition="props.currentPosition"
        :tabName="TAB_ICONS_NAMES.JDROID"
        v-if="props.tabPosition == TAB_BUTTON_POSITION.MAXIMIZE"
      >
      </TabCompTitleBar>

      <div
        v-if="promoteGetCredit || chatList.length"
        class="surface-secondary-base flex w-full items-center justify-end border-b border-new-neutral-200 p-2 dark:border-new-neutral-700"
        :class="[
          { 'h-[50px]': props.tabPosition === TAB_BUTTON_POSITION.BOTTOM },
          { 'h-10': props.tabPosition === TAB_BUTTON_POSITION.MAXIMIZE }
        ]"
      >
        <Credit v-if="promoteGetCredit" />
        <button
          v-if="chatList.length"
          class="ml-1 flex items-center justify-center pr-2 text-xs font-normal"
          @click="clearChat()"
        >
          <FontAwesomeIcon
            icon="fa-solid fa-arrows-rotate"
            class="color-secondary-700 dark:color-neutral-300 h-4 w-4 pr-2"
          />
          Clear Inputs
        </button>
      </div>

      <Welcome v-if="showWelcome" :currentPosition="props.currentPosition" />
      <Chat :currentPosition="props.currentPosition" :is-chat-jdroid="false" v-else />
    </div>
  </div>
</template>
